<template>
    <div class="flex border-t border-base-200 bg-base-100">
        <RouterLink
            :to="{ name: 'today' }"
            class="flex-1 flex flex-col items-center justify-center py-3 gap-1 text-xs font-medium transition-colors"
            :class="$route.name === 'today' ? 'text-primary' : 'text-base-content/40'"
        >
            <AppIcon
                name="calendar"
                :size="22"
            />
            Today
        </RouterLink>

        <div class="flex-1 flex flex-col items-center justify-center py-3 gap-1">
            <button
                class="w-12 h-12 rounded-full bg-primary text-primary-content flex items-center justify-center transition-opacity"
                :class="polling ? 'opacity-60' : ''"
                :disabled="polling"
                @click="$emit('add')"
            >
                <AppIcon
                    :name="polling ? 'loader' : 'plus'"
                    :size="22"
                />
            </button>
        </div>

        <RouterLink
            :to="{ name: 'week' }"
            class="flex-1 flex flex-col items-center justify-center py-3 gap-1 text-xs font-medium transition-colors"
            :class="$route.name === 'week' ? 'text-primary' : 'text-base-content/40'"
        >
            <AppIcon
                name="chart-bar"
                :size="22"
            />
            Week
        </RouterLink>
    </div>
</template>

<script setup>
import AppIcon from 'components/icons/app-icon.vue';

defineProps({
    polling: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['add']);
</script>
